export default __webpack_public_path__ + "static/media/searchIcon.fa8232a3.svg";